import useFundingExperiment from 'features/onboarding/hooks/useFundingExperiment';
import FundingScreen from 'features/onboarding/screens/FundingScreen/FundingScreen';
import FundingScreenV2 from 'features/onboarding/screens/FundingScreenV2/FundingScreenV2';

const FundingScreenRouter = () => {
  const { variant } = useFundingExperiment();
  return variant === 'test' ? <FundingScreenV2 /> : <FundingScreen />;
};

export default FundingScreenRouter;
